import { constructEventsWithNamespace } from "./event-bus-helpers";
const EventBusTopicMap = {
    CompanyPages: {
        CompanyDetailsWidgetState: "company-details-widget-state",
        CompanyInfo: "company-info",
        EsgOverviewWidgetState: "esg-overview-widget-state",
        Financials: {
            CapitalStructureWidgetState: "capital-structure-widget-state",
            DebtSummaryWidgetState: "debt-summary-widget-state",
            KeyFinancialsWidgetState: "key-financials-widget-state",
            PeerComparisonWidgetState: "peer-comparison-widget-state",
            SegmentDataWidgetState: "segment-data-widget-state",
        },
        RatedDescriptionState: "rated-description",
        RatingsWidgetState: "ratings-widget-state",
        RelatedResearch: {
            ReportsResearchWidgetState: "reports-research-widget-state",
            SectorOutlookWidgetState: "sector-outlook-widget-state",
            SectorReportsWidgetState: "sector-reports-widget-state",
            SectorResearchWidgetState: "sector-research-widget-state",
        },
    },
    Forms: {
        Feedback: {
            ModalOpen: "forms-feedback-modal-open",
        },
        FeedbackState: "forms-feedback-state",
    },
    IsAuthenticated: "is-authenticated",
    SearchbarOpen: "searchbar-open",
    SectorViews: {
        HighlightsMacroOutlookState: "sector-highlights-macro-outlook",
        HighlightsState: "sector-highlights",
    },
    Shell: {
        AemMenu: { LanguageNodes: "language-nodes" },
        LiveChat: "live-chat",
        PageMeta: "page-meta",
    },
    SignInModalOpen: "sign-in-modal-open",
    SignOutPending: "sign-out-pending",
    Subscription: {
        LockedResearchModalOpen: "locked-research-modal",
        OutOfSubscriptionModalOpen: "out-of-subscription-modal-open",
        UpsellModalOpen: "upsell-modal-open",
    },
    UserDetails: "user-details",
};
export const EventBusTopic = Object.freeze(constructEventsWithNamespace(EventBusTopicMap));
//# sourceMappingURL=event-bus-topics.js.map